import styled from 'styled-components';

// Components
import { ToastShell, ToastText } from '../shared/styles';
import { Typography } from '../../display/Typography';

/**
 * Caja común (ver `../shared/styles.ts`); aquí solo el borde que lo distingue.
 *
 * Es el toast que destapó el problema: lleva DOS líneas —título y nombre del
 * fichero— más el botón de abrir, así que con el `height: 6.6rem` fijo de antes
 * el texto salía aplastado contra los bordes (visto en tablet, 2026-08-16).
 */
export const Container = styled(ToastShell)`
  border: 1px solid ${({ theme }) => theme.colors.green};
`;

export const IconContainer = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-left: 1.2rem;
  /* min-width 0 deja que el hijo se encoja: sin esto un nombre de fichero
   * largo estira el flex y el recorte con puntos suspensivos no llega a
   * aplicarse nunca. */
  min-width: 0;
  flex: 1;
`;

export const Text = styled(ToastText)`
  color: ${({ theme }) => theme.colors.green};
`;

/**
 * El nombre del fichero se recorta con puntos suspensivos en vez de partirse:
 * repartido en tres líneas no se lee mejor, y el nombre completo sigue
 * disponible en el `title`.
 */
export const Filename = styled(Typography)`
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.greyDark};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OpenButton = styled.button`
  margin-left: 1.2rem;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0.8rem;
  cursor: pointer;
  font-family: inherit;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.green};
`;
